module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1200-4f3996dd7836a1cd726d8e5691ec9d7b.webp";